import axios from "axios"
import host from './host'

const path = {
    auth: "/api/auth-patient",
    patient: "/api/patients",
    enums: "/api/enums",
    dialy_controls: "/api/dialy_controls",
    config: "/api/configs"
}

export default {
    auth: {
        login: body => {
            return axios.post(`${host}${path.auth}/authenticate`, body)
        },
        forgotPassword: email => {
            return axios.get(`${host}${path.auth}/forgot-password`, { params: { email } })
        },
        setAuthorizationToken: async (formatedToken) => {
            axios.defaults.headers.common.Authorization = formatedToken
            await localStorage.setItem('token', formatedToken)
            return
        },
        removeAuthorizationToken: async () => {
            axios.defaults.headers.common.Authorization = null
            await localStorage.removeItem('token')
            return
        },
        getEnums: params => {
            return axios.get(`${host}/api/enums`, { params });
        }
    },
    patient: {
        get: patient_id => {
            return axios.get(`${host}${path.patient}/${patient_id}`)
        },
    },
    enums: {
        find: name => {
            return axios.get(`${host}${path.enums}/${name}`);
        },
    },
    dialy_controls: {
        listCurrents: () => {
            return axios.get(`${host}${path.dialy_controls}/patient/listCurrents`);
        },
        listExercising: () => {
            return axios.get(`${host}${path.dialy_controls}/patient/listExercising`);
        },
        end: body => {
            return axios.put(`${host}${path.dialy_controls}/patient/end`, body)
        },
        finishExercise: (body) => {
            return axios.post(`${host}${path.dialy_controls}/patient/finishExercise/`, body)
        },
        addEventExercise: body => {
            return axios.put(`${host}${path.dialy_controls}/patient/add/exercise/${body.id}`, body)
        },
        addEventMonitory: body => {
            return axios.put(`${host}${path.dialy_controls}/patient/add/monitory/${body.id}`, body)
        },
        create: body => {
            return axios.post(`${host}${path.dialy_controls}/patient/`, body)
        },
        createInExercise: (body) => {
            return axios.post(`${host}${path.dialy_controls}/patient/inExercise/`, body)
        },
        updateDialyOngoingDate: (id) => {
            return axios.post(`${host}${path.dialy_controls}/patient/update-ongoing-date/${id}`)
        },
    },
    config: {
        list: () => {
            return axios.get(`${host}${path.config}/patient/`);
        },
    }
}
